module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Semibold.ac4348810472498dba21e45154dadced.ttf";